import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IntersectionObserverDirective } from './directives/intersection-observer.directive';
import { ApplicationService } from './services/application.service';
import { CheckPlatformService } from './services/check-platform.service';

const MODULES = [
  // Do NOT include UniversalModule, HttpModule, or JsonpModule here
  CommonModule,
  RouterModule,
];

const PIPES: any = [
  // put pipes here
];

const COMPONENTS: any = [IntersectionObserverDirective];

const PROVIDERS: any = [
  ApplicationService,
  CheckPlatformService,
];

@NgModule({
  imports: [...MODULES],
  declarations: [...PIPES, ...COMPONENTS],
  exports: [...MODULES, ...PIPES, ...COMPONENTS],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [...PROVIDERS],
    };
  }
}
